import React, { useEffect, useState } from "react";
import Search from "../../../components/Search";
import { useDispatch, useSelector } from "react-redux";
import { Avatar, Divider, Dropdown, Table } from "antd";
import svg27 from "../../../assets/svg/svg27.svg";
import svg15 from "../../../assets/svg/svg15.svg";
import svg31 from "../../../assets/svg/svg31.svg";
import BreadCrumb from "../../../layout/BreadCrumb";
import CardLoading from "../../../components/CardLoading";
import { Link, useNavigate } from "react-router-dom";
import { fetchData } from "../../../features/fetch/fetchSlice";
import { setActiveObj } from "../../../features/obj/objSlice";
import svg29 from "../../../assets/svg/svg29.svg";
import svg30 from "../../../assets/svg/svg30.svg";
import placeholderImg from "../../../assets/img/placeholderImg.png";
import ConfirmModal from "../../../components/ConfirmModal";
import { formatImgPath, getColorFromName, getFirstLetter, getInitials } from "../../../utils";

function UsersTable() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const url = "usr/users-list";
  const { loading, data, count } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
    count: state.fetch.count[url] || 0,
  }));

  const [openDelete, setOpenDelete] = useState(false);
  const handleOpenDelete = () => {
    setOpenDelete(true);
  };
  const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  const handleDelete = () => {};

  const [searchInput, setsearchInput] = useState(null);
  const [prodd, setProdd] = useState("");

  const handleSearch = (e) => {
    setsearchInput(e.target.value);
    setPageIndex(0);
    dispatch(
      fetchData({
        url: url,
        search: e.target.value === "" ? null : e.target.value,
        limit: pageSize,
        start: 0,
      })
    );
  };

  const handleEdit = async () => {
    await dispatch(setActiveObj({ key: "usersData", data: prodd }));
    await navigate("/user/user-add");
  };
  const handleView = async () => {
    await dispatch(setActiveObj({ key: "usersData", data: prodd }));
    await navigate("/user/user-view");
  };
  const handleViewName = async (item) => {
    await dispatch(setActiveObj({ key: "usersData", data: item }));
    await navigate("/user/user-view");
  };
  const handleDisable = () => {
    handleOpenDelete();
  };
  const handleAdd = async () => {
    await dispatch(setActiveObj({ key: "usersData", data: {} }));
    await navigate("/user/user-add");
  };

  const settingItems = [
    {
      key: "0",
      label: (
        <div onClick={handleView}>
          <Link className="flex actions-text gap-x-[.75rem] my-2 ">
            <img src={svg15} alt="svg15" /> View
          </Link>
          <div className="mt-[1rem]">
            <Divider />
          </div>
        </div>
      ),
    },
    {
      key: "1",
      label: (
        <div onClick={handleEdit}>
          <Link className="flex actions-text gap-x-[.75rem] my-2 ">
            <img src={svg31} alt="svg31" /> Edit
          </Link>
          <div className="mt-[1rem]">
            <Divider />
          </div>
        </div>
      ),
    },
    // {
    //   key: "2",
    //   label: (
    //     <div>
    //       <Link
    //         onClick={handleDisable}
    //         className="flex actions-text gap-x-[.75rem] my-2 "
    //       >
    //         <img src={svg30} alt="svg30" /> Disable
    //       </Link>
    //     </div>
    //   ),
    // },
  ];

  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      render: (_, __, index) => index + 1,
      width: 20,
    },
    {
      title: "Name",
      render: (item) => {
        return (
          <div
            className="flex items-center  gap-x-[.75rem] cursor-pointer"
            onClick={() => handleViewName(item)}
          >
            {
              item?.usrLogo ? (
                <div className="w-[2rem] h-[2rem] rounded-full">
                <img
                  className="w-full h-full"
                  src={formatImgPath(item?.usrLogo)}
                  alt={item?.usrLogo}
                />
              </div>
              ):(
                <Avatar style={{ backgroundColor: getColorFromName(item?.fullNames) }}>{getInitials(item?.fullNames)}</Avatar>
              )
            } 
          
            <div className="flex flex-col ">
              <span className="details_h !text-[#424242]">
                {item?.fullNames}
              </span>
              <span className="typography_2 !text-[#6B7280]">
                {item?.email}
              </span>
            </div>
          </div>
        );
      },
      sorter: (a, b) => a.fullNames.localeCompare(b.fullNames),
    },
    
    {
      title: "National ID",
      dataIndex:"usrNationalId",
      sorter: (a, b) => a.usrNationalId.localeCompare(b.usrNationalId),
    },
     
    {
      title: "Profile",
      dataIndex:"usrProfile",
      sorter: (a, b) => a.usrProfile.localeCompare(b.usrProfile),
    },
         
    {
      title: "Department",
      dataIndex:"usrDepartment",
      sorter: (a, b) => a.usrDepartment.localeCompare(b.usrDepartment),
    },
    // {
    //   title: "Department/Profile",
    //   render: (item) => {
    //     return (
    //       <div className="flex flex-col gap-y-[1rem]">
    //         <span className="details_h !text-[#424242]">
    //           {item?.usrDepartment}
    //         </span>
    //         <span className="typography_2 !text-[#6B7280]">
    //           {item?.usrProfile}
    //         </span>
    //       </div>
    //     );
    //   },
    //   sorter: (a, b) => a.usrDepartment.localeCompare(b.usrDepartment),
    // },

    {
      title: "Status",
      dataIndex: "usrUserStatus",
      render: (item) => {
        const colors = {
          ACTIVE: "#ABEFC6",
          DELETED: "#FECFCA",
          INACTIVE: "#F1F3F5",
        };

        return (
          <div
            className={`${
              item === "ACTIVE"
                ? "text-[#067647]"
                : item === "INACTIVE"
                ? "text-[#706F6F]"
                : item === "DELETED"
                ? "text-[#B42318]"
                : "text-[#FFF]"
            } inline-block rounded-[8px] px-[8px] py-[4px] w-auto font-interSans !text-[.75rem]`}
            style={{
              backgroundColor: colors[item] || "darkGreen",
            }}
          >
            {item}
          </div>
        );
      },
    },

    {
      title: "Actions",
      render: (item) => (
        <>
          <Dropdown
            overlayStyle={{
              width: "250px",
            }}
            trigger={"click"}
            menu={{ items: settingItems }}
            placement="bottom"
          >
            <button onClick={() => setProdd(item)}>
              <img src={svg27} alt="svg27" />
            </button>
          </Dropdown>
        </>
      ),
    },
  ];

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchUsersData(page, size) {
    await dispatch(
      fetchData({
        url: url,
        limit: size ?? pageSize,
        start: page ?? pageIndex,
        search: searchInput || null,
      })
    );
  }

  useEffect(() => {
    fetchUsersData();
  }, []);

  if (loading && !searchInput) return <CardLoading />;
  return (
    <div className="lg:min-h-[88vh] flex flex-col">
      <BreadCrumb breadcrumbs={[{ title: "Users" }]} />
      <div className="flex flex-col w-full lg:px-[1.25rem] flex-1  white_card mt-[1.25rem]">
        <div className="flex items-center justify-between">
          <div className="form-add-h">All SDI Users</div>
          <div className="w-[150px]">
            <button
              onClick={() => handleAdd()}
              className="cstm-btn-2 gap-x-[.5rem]"
            >
              <img src={svg29} alt="svg29" />
              <span className="">Add User</span>
            </button>
          </div>
        </div>
        <Divider />
        <div className="lg:w-[29.1875rem] w-auto mt-[1.25rem]">
          <Search
            searchInput={searchInput}
            handleSearch={handleSearch}
            text={"Search user..."}
          />
        </div>

        <div className="dash-inner-page mt-[24px] max-w-full w-full overflow-x-auto">
          <section>
            <Table
              rowSelection={false}
              className="mt-[1.31rem] w-full"
              scroll={{
                x: 1200,
              }}
              rowKey={(record) => record?.usrId}
              columns={columns}
              dataSource={data}
              loading={loading}
              pagination={{
                position: ["bottomRight"],
                current: pageIndex + 1,
                total: count,
                pageSize: pageSize,
                onChange: (page, size) => {
                  setPageIndex(page - 1);
                  setPageSize(size);
                  fetchUsersData(page - 1, size);
                },
                showSizeChanger: false,
                hideOnSinglePage: true,
              }}
            />
          </section>
        </div>
      </div>

      <ConfirmModal
        open={openDelete}
        handleCancel={handleCloseDelete}
        handleSubmit={handleDelete}
        loading={loading}
        content="Are you sure you want perfom this action?"
        type="alert"
        btnTitle="Disable"
      />
    </div>
  );
}

export default UsersTable;
